// extracted by mini-css-extract-plugin
module.exports = {"interview-kit-card":"styles-module__interview-kit-card___1rUiY"};